import { render, staticRenderFns } from "./credentialsInterfaceForm.vue?vue&type=template&id=4a4483ad&scoped=true&"
import script from "./credentialsInterfaceForm.vue?vue&type=script&lang=js&"
export * from "./credentialsInterfaceForm.vue?vue&type=script&lang=js&"
import style0 from "./credentialsInterfaceForm.vue?vue&type=style&index=0&id=4a4483ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4483ad",
  null
  
)

export default component.exports